import btcUsdMaxCsv from './btc-usd-max.csv';

/** UTC calendar day `YYYY-MM-DD` → BTC price in USD (one row per day in source file). */
let btcUsdByUtcDay: Map<string, number> | null = null;
let sortedUtcDayKeys: string[] = [];

function parseBtcUsdCsv(text: string): Map<string, number> {
  const map = new Map<string, number>();
  const lines = text.trim().split(/\r?\n/);
  for (let i = 1; i < lines.length; i++) {
    const line = lines[i].trim();
    if (!line) continue;
    const firstComma = line.indexOf(',');
    if (firstComma < 0) continue;
    const snapped = line.slice(0, firstComma).trim();
    const rest = line.slice(firstComma + 1);
    const secondComma = rest.indexOf(',');
    const priceStr = secondComma >= 0 ? rest.slice(0, secondComma) : rest;
    const price = parseFloat(priceStr.trim());
    if (!Number.isFinite(price) || price <= 0) continue;
    const dayKey = snapped.slice(0, 10);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(dayKey)) continue;
    map.set(dayKey, price);
  }
  return map;
}

export function ensureBtcUsdDailyLoaded(): void {
  if (btcUsdByUtcDay != null) return;
  btcUsdByUtcDay = parseBtcUsdCsv(btcUsdMaxCsv);
  sortedUtcDayKeys = Array.from(btcUsdByUtcDay.keys()).sort();
}

/** USD per 1 BTC at UTC calendar day of `date`, or `null` if outside bundled range. */
export function btcUsdPerUnitOnUtcDayNearest(date: Date): number | null {
  ensureBtcUsdDailyLoaded();
  const map = btcUsdByUtcDay!;
  const keys = sortedUtcDayKeys;
  if (keys.length === 0) return null;
  const y = date.getUTCFullYear();
  const m = String(date.getUTCMonth() + 1).padStart(2, '0');
  const d = String(date.getUTCDate()).padStart(2, '0');
  const dayKey = `${y}-${m}-${d}`;
  const hit = map.get(dayKey);
  if (hit != null) return hit;
  if (dayKey < keys[0]) return map.get(keys[0]) ?? null;
  if (dayKey > keys[keys.length - 1]) return map.get(keys[keys.length - 1]) ?? null;
  let i = keys.length - 1;
  while (i >= 0 && keys[i] > dayKey) i--;
  return i >= 0 ? map.get(keys[i])! : map.get(keys[0])!;
}
